var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('LoadingInner')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }